export const enum E_TipoDocumentoDesviacion {
  CargadoInforme = 1,
  ArbolCausal = 2,
  EvidenciaDesviacion = 3,
  EvidenciaCausa = 4,
  PlanAccion = 5,
}
